const replaceBullets = () => {
    return {
        svg: `<svg class='u-inline-block u-h-auto' width='20' height='40' viewBox='0 0 96 88' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M72.612 18.4829C73.5068 10.0245 69.4234 2.65892 63.4915 2.03144C57.5596 1.40395 52.0256 7.75217 51.1308 16.2106C50.2361 24.669 54.3195 32.0346 60.2513 32.662C66.1832 33.2895 71.7173 26.9413 72.612 18.4829Z' fill='black'/>
<path d='M35.7205 32.6209C41.6524 31.9934 45.7358 24.6279 44.841 16.1694C43.9463 7.71104 38.4122 1.36282 32.4803 1.9903C26.5485 2.61779 22.4651 9.98336 23.3598 18.4418C24.2546 26.9002 29.7886 33.2484 35.7205 32.6209Z' fill='black'/>
<path d='M92.432 43.552C94.269 35.304 91.0384 27.5665 85.2163 26.2698C79.3942 24.9731 73.1852 30.6082 71.3482 38.8562C69.5112 47.1042 72.7417 54.8417 78.5639 56.1384C84.386 57.4352 90.5949 51.8 92.432 43.552Z' fill='black'/>
<path d='M17.4248 56.1355C23.2469 54.8388 26.4775 47.1012 24.6404 38.8532C22.8034 30.6052 16.5945 24.9701 10.7723 26.2668C4.95023 27.5635 1.71967 35.3011 3.55669 43.5491C5.39371 51.7971 11.6027 57.4322 17.4248 56.1355Z' fill='black'/>
<circle cx='48' cy='64' r='24' fill='black'/>
</svg>`,
    init() {

      var replacement = this.$el.innerHTML.replaceAll('•', this.svg);
      this.$el.innerHTML = replacement;
        }
    };
}

window.replaceBullets = replaceBullets;

export default replaceBullets;
